import React, { useEffect, useTransition } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import './assets/css/responsive.css';
import './assets/css/homepage-responsive.css';
import './assets/css/common.css';
import './assets/js/main.js';
import 'slick-carousel';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import RoomSuits from './pages/RoomSuits';
import Navbar from './Layout/Navbar';
import Footer from './Layout/Footer';
import MoreInfo from './components/AboutUS/MoreInfo';
import Dinning from './pages/Dinning';
import Event from './pages/Event';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Faq from './pages/Faq';
import Career from './pages/Career';
import Amenities from './pages/Amenities';
import Gallary from './pages/Gallary';
import Login from './pages/Auth';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './auth/AuthProvider';
import { useAppDispatch, useAppSelector } from './Hooks';
import { getMenuAccessData } from './features/MenuAceess';
import { getFooterData } from './features/Footer';
import BlogDetails from './pages/BlogDetails';

// import I18nSetup from './i18n'; 
import { getMultiLanguageData, resetLoader } from './features/multiLanguage';
import setupI18n from './i18n'; 
import { Loader } from './components/common/Loader';

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { menu } = useAppSelector(state => state.menuAccess);
  console.log(menu, 'menu');
  const { multiLanguage,multiLanguageLoader } = useAppSelector(state => state.multiLanguage);
  const [isPending, startTransition] = useTransition()
  console.log(multiLanguageLoader,'multiLanguageLoader');
  
  useEffect(() => {
    startTransition(() => {
    dispatch(getMultiLanguageData())

    dispatch(getMenuAccessData())
    dispatch(getFooterData())
    setupI18n();
    
    })
  }, [])
  
  useEffect(()=>{
    const init = async() => {
      if(multiLanguage && multiLanguage.length>0){

       await setupI18n(multiLanguage);
       dispatch(resetLoader())
      }
    }
    init()

  },[multiLanguage])
console.log(multiLanguage,'multiLanguage');
// if (multiLanguageLoader) {
//   <Loader />
// }
  return (
    <>
  {
  multiLanguageLoader || isPending  ? (
  <Loader />

  ):(
<AuthProvider>
        <Router >
          <div>
            <Navbar />
            <Routes>
              {
                menu && menu.home && menu.home.home &&
                <Route path="/" element={<Home />} />}
              {
                menu && menu.about_us && menu.about_us.about_us &&
                <Route path="/about-us" element={<AboutUs banner_title='about_us' />} />
              }
              {
                menu && menu.room_suits && menu.room_suits.room_suits &&
                <Route path="/room-suits" element={<RoomSuits banner_title="room_suit" />} />
              }
              {
                menu && menu.dinning && menu.dinning.dinning &&
                <Route path="/dinning" element={<Dinning banner_title="dinning" />} />
              }
              {
                menu && menu.meeting_events && menu.meeting_events.meeting_events &&
                <Route path="/meetings-events" element={<Event banner_title='meeting' />} />
              }
              {
                menu && menu.blogs &&
                <>
                <Route path="/blogs" element={<Blog banner_title='Blog' />} />
                <Route path="/blogs/:id" element={<BlogDetails banner_title='blogs' />} />
                </>

              }
              {
                menu && menu.contact &&
                <Route path="/contact" element={<Contact banner_title='contact' />} />
              }

              {
                menu && menu.faq &&
                <Route path="/faq" element={<Faq banner_title='faq' />} />
              }
              {
                menu && menu.amenities &&
                <Route path="/amenities" element={<Amenities banner_title='amenities' />} />
              }
              {
                menu && menu.career &&
                <Route path="/career" element={<Career banner_title='career' />} />
              }
              {
                menu && menu.gallery &&
                <Route path="/gallery" element={<Gallary banner_title="gallery" />} />
              }
              <Route path="/login" element={<Login />} />
            </Routes>
            {
              menu && menu.footer &&
              <>
              <MoreInfo />
            <Footer />
              
              </>
}
          </div>
        </Router>
        <ToastContainer position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        // transition:Bounce 
        />
      </AuthProvider>
  )
  }
      
    </>
  );


}

export default App;
